export const KAKAO_CHANNEL = 'http://pf.kakao.com/_xbxolKb/chat';
export const ZALO_CHANNEL = 'https://zalo.me/1167382348352876207';
